import { agentProductionTerms } from '../../../constants';
import { activityToolTips, tabModes } from '../../constants/agentProductionConstants';
import {
    COLUMN_GROUP_SEARCH,
    COLUMN_GROUP_MLS,
} from '../../helpers/agentProductionHelpers';
import { transformSchemaTableColumns } from '../../helpers/schemaTableHelpers';

export const getActivityTableSettings = (columns, dateRangesText, activityCount) => {

    transformSchemaTableColumns(activityToolTips, tabModes.ACTIVITY);
    const getCountDisplayedColumns = headerPlacement => columns.filter(c => c.isDisplayed && 
        c.headerPlacement === headerPlacement).length;


    const addHeaderColumn = ({ headerColumns, title, colSpan, columnObjectName }) => {
        return {
            ...headerColumns,
            [columnObjectName]: {
                title,
                attrs: {
                    colSpan,
                    className: 'border text-center'
                }
            }
        }
    };

    let headerColumns = {};

    const countDisplayedColumnsSearch = getCountDisplayedColumns(COLUMN_GROUP_SEARCH);
    if (countDisplayedColumnsSearch) {
        headerColumns = addHeaderColumn({
            headerColumns,
            title: `${agentProductionTerms.currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to}) - ${activityCount} ACTIVITIES`,
            colSpan: countDisplayedColumnsSearch,
            columnObjectName: COLUMN_GROUP_SEARCH
        });
    }

    const countDisplayedColumnsMls = getCountDisplayedColumns(COLUMN_GROUP_MLS);
    if (countDisplayedColumnsMls) {
        headerColumns = addHeaderColumn({
            headerColumns,
            title: `${agentProductionTerms.allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
            colSpan: countDisplayedColumnsMls,
            columnObjectName: COLUMN_GROUP_MLS
        });
    }

    return [
        headerColumns
    ];
};
